'use es6';
/**
 * Categories of the settings managed by IDE.
 *
 * @typedef {Object} enums/settings/Categories
 * @enum {String}
 */

/** @type {String} Catchall or no category specified. */

export const NONE = 'NONE';
/** @type {String} All IDE settings related to code input. */

export const CODE = 'CODE';
/** @type {String} ESLint settings for IDE. */

export const JSLINT = 'JSLINT';